<template>
  <div class="container-transcript my-3">
    <div v-if="transcriptInfo || transcriptStatus === 3" class="top-menu-transcript">
      <v-row v-if="!searchOn" align="center" justify="start" dense style="padding: 1px 0">
        <v-col cols="auto">
          <v-btn dark color="#eee" plain @click="allCopy()">
            <span class="material-icons-round mr-1 btn-span" translate="no">copy</span>
            {{ $t('copy') }}
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn dark color="#eee" plain @click=";(searchOn = true), (editIndex = null)">
            <span class="material-icons-round mr-1 btn-span" translate="no">search</span>
            {{ $t('search') }}
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <select-language
            :plain="true"
            :autoDetect="false"
            :isClOrganizer="isClOrganizer"
            btnName="Translate"
            btnIcon="translate"
            basicBtnName="Translate"
            basicBtnColor="#21343b"
            basicBtnFontColor="#ddd"
            basicBtnIcon="translate"
            basicBtnIconColor=""
            @language="setTranslate($event['label'])"
            :initialLanguage="
              transcriptInfo ? transcriptInfo.tsLanguage.replace(/^[a-z]/, (char) => char.toUpperCase()) : ''
            "
          ></select-language>
        </v-col>
      </v-row>
      <v-row v-else align="center" justify="start" dense>
        <v-col cols="">
          <v-text-field
            dark
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            solo
            single-line
            dense
            hide-details
            id="transcriptSearchField"
          ></v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-btn dark class="close" color="#eee" icon @click="searchOn = false">
            <span class="material-icons-round btn-span" translate="no">close</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <!-- <div v-if="computedWsClipCnt['planType'] !== 'Plus'">
      <v-row dense no-gutters>
        <v-col cols="12" align="center" class="loading-text-big mt-3 mb-1">{{ $t('transcriptUpgradePlan') }}</v-col>
      </v-row>
    </div> -->

    <div v-if="!transcriptSegments || transcriptSegments.length === 0">
      <!-- Transcript 서버에서 변환중일때 화면 -->
      <v-row class="mx-6" v-if="isShowLoading" dense no-gutters>
        <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
          {{ $t('transcriptLoadingTitle') }}
        </v-col>
        <v-col cols="12" align="center" class="loading-text-small mb-3">
          {{ $t('transcriptLoadingContent') }}
        </v-col>
      </v-row>
      <!-- Transcript 을 선택하지 않거나 너무 짧을 경우 화면 -->
      <v-row class="mx-6" v-else-if="isUncheckedOrTooShort" dense no-gutters>
        <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
          {{ $t('transcriptUncheckedOrTooShortContent') }}
        </v-col>
      </v-row>
      <!-- Transcript 변환 실패시 화면 -->
      <v-row class="mx-6" v-else-if="isShowFail" dense no-gutters>
        <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
          {{ $t('error') }}
        </v-col>
      </v-row>
      <div v-else>
        <!-- Loading 중 -->
        <v-skeleton-loader
          v-if="isShowSuccess && isLoading"
          dark
          class="mx-auto my-3"
          max-height="71"
          type="image"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="isShowSuccess && isLoading"
          dark
          class="mx-auto my-3"
          max-height="71"
          type="image"
        ></v-skeleton-loader>

        <!-- Transcript 변환 성공 후 화면 -->
        <v-row class="mx-6" v-if="isEmptyTranscript" dense no-gutters>
          <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
            {{ $t('transcriptFailContent') }}
          </v-col>
        </v-row>
        <v-row
          class="mx-6"
          v-if="(transcriptSegments === undefined || transcriptSegments === null) && !isLoading && !isEmptyTranscript"
        >
          <v-col cols="12" align="center" class="loading-text-big mt-16 mb-1">
            {{ $t('noSegments') }}
          </v-col>
        </v-row>
      </div>
    </div>

    <v-card
      v-else
      :ref="`transcriptCard-${item.sgId}`"
      class="wrap-transcript-card my-3"
      elevation="0"
      v-for="(item, index) in filteredItem"
      :key="item.sgId"
      color="#31434f"
      dark
      :ripple="false"
      @click="onClickTranscriptCard(item)"
      @touchend="onClickTranscriptCard(item)"
      :class="{ transcriptCardClicked: clickedTranscriptCardComparison(item) }"
      :style="item.isDeleteLoading ? 'opacity: 0.5' : ''"
    >
      <v-row dense no-gutters align="start" class="d-flex">
        <v-col cols="1" class="d-flex transcript-col py-4 px-4" style="min-width: 90px">
          <v-textarea
            v-if="editIndex != null && editIndex === index"
            class="edit-timestamp mr-3"
            dark
            solo
            dense
            rows="1"
            single-line
            auto-grow
            hide-details
            :v-model="editTimeStamp(item)"
            :value="convertSecondsToTime(item.startTime)"
            @keydown.enter.prevent="convertInputToTime($event.target.value)"
            @blur="convertInputToTime($event.target.value)"
            @keypress="isNumber($event)"
          ></v-textarea>
          <div v-else class="transcript-timestamp">{{ convertSecondsToTime(item.startTime) }}</div>
        </v-col>
        <v-col cols="" class="transcript-content my-4 mx-1" style="display: inline-block; min-width: 100px">
          <v-textarea
            v-if="editIndex != null && editIndex === index"
            class="edit-content pr-3"
            dark
            solo
            dense
            auto-grow
            rows="1"
            hide-details
            v-model="item.content"
            :value="item.content"
            autofocus
          ></v-textarea>
          <div v-else class="pr-10" v-html="highlighted(item.content)"></div>
        </v-col>
        <v-col cols="12" v-if="editIndex != null && editIndex === index" class="wrap-edit-menu pr-4 mb-4" align="end">
          <v-btn
            dark
            class=""
            color="#eee"
            plain
            @click.stop="submitEditGoal(index, false), (item.transcriptMenu = false), (item.content = oldValue)"
          >
            <span class="material-icons-round mr-1 btn-span" translate="no">cancel</span>
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            dark
            class="btn-save"
            color="#eee"
            plain
            :loading="isEditLoading"
            @click.stop="submitEditGoal(index, true), (isEdit = true), (item.transcriptMenu = false)"
          >
            <span class="material-icons-round mr-1 btn-span" translate="no">save</span>
            {{ $t('save') }}
          </v-btn>
        </v-col>
        <v-col v-else cols="auto" class="d-flex transcript-col-btn">
          <div
            v-show="item.transcriptMenu || item.isDeleteLoading"
            no-gutters
            align="start"
            class="dot-comment flex-column"
          >
            <v-menu v-model="item.transcriptMenu" offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn plain v-bind="attrs" v-on="on" class="dot-menu" :loading="item.isDeleteLoading">
                  <span
                    style="font-size: 16px; font-weight: 500"
                    class="material-icons-round white--text"
                    translate="no"
                  >
                    {{ item.transcriptMenu ? 'close' : 'more_horiz' }}
                  </span>
                </v-btn>
              </template>
              <div class="container-menu-transcript">
                <v-row align="center" justify="center" dense>
                  <v-col v-if="isClOrganizer" cols="12">
                    <v-btn
                      dark
                      block
                      class=""
                      color="#eee"
                      plain
                      @click="editGoal(item, index), (item.transcriptMenu = false)"
                    >
                      <span class="material-icons-round mr-1 btn-span" translate="no">edit</span>
                      {{ $t('edit') }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn dark block class="" color="#eee" plain @click="copy(item)">
                      <span class="material-icons-round mr-1 btn-span" translate="no">copy</span>
                      {{ $t('copy') }}
                    </v-btn>
                  </v-col>
                  <v-col v-if="isClOrganizer || isMtOrganizer || isWsOwner || isWsManager" cols="12">
                    <v-btn
                      :loading="isDeleteLoading"
                      dark
                      block
                      class=""
                      color="#eee"
                      plain
                      @click="deleteTranscript(item, index)"
                    >
                      <span class="material-icons-round mr-1 btn-span" translate="no">delete</span>
                      {{ $t('delete') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-menu>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
import { updateTranscriptInfo } from '@/services/clipApi'
import { mapGetters, mapState, mapActions } from 'vuex'
import SelectLanguage from '@/views/modal/SelectLanguage'

export default {
  name: 'Detailtranscript',
  components: { SelectLanguage },
  props: [],
  created() {},
  beforeDestroy() {},
  mounted() {
    // Clip Transcript 호출
    this.getTranscriptInfo()
    // this.hasTranscript()

    // setTimeout(() => (this.searchItem = this.dummyData))
  },
  updated() {},
  unmounted() {},
  data() {
    return {
      isCardClicked: false,
      cardClickedId: null,

      // clickedTranscriptCard: null,
      searchOn: false,
      search: '',
      searchItem: null,
      transcriptMenu: false,
      editIndex: null,

      //Transcript Data 관련 변수
      transcriptArray: null,
      transcriptSegments: null,
      filteredSegements: null,
      transcriptSegmentsIndex: 0,
      threshold: 0.5,

      isEditLoading: false,
      isDeleteLoading: false,
      isEditing: false,

      oldValue: '',
      editedTimeStamp: '',

      // Skeleton Loading
      isLoading: true,
      // 데이터는 가져왔지면 array length 가 0 인 경우
      isEmptyTranscript: false,
    }
  },
  methods: {
    async getTranscriptInfo() {
      try {
        // 변환중이거나 변환 성공했을때만 호출
        if (this.currentClip && (this.isShowLoading || this.isShowSuccess)) {
          // if (this.isShowSuccess) this.isLoading = true
          await this.$store.dispatch('getTranscriptInfo', true)
        } else {
          // Todo: Clip 이 없을때 오류 표시
        }
      } catch (error) {
        console.log('transcript error ', error)
      }
    },
    async setTranslate(language) {
      try {
        this.transcriptSegments = null
        this.setFilteredSegments(null)
        this.searchItem = null
        this.totalSectionList[this.sectionIndex].clipList[this.clipIndex]['transcriptStatus'] = 0
        this.currentClip['transcriptStatus'] = 0
        this.setTotalSectionList(this.totalSectionList)
        this.setCurrentClip(this.currentClip)

        this.setTranslateTranscript({
          tsId: this.transcriptInfo['tsId'],
          tsLanguage: language,
        })
      } catch (error) {
        console.log('translate transcript error : ', error)
      }
    },
    ...mapActions([
      'setClickedTranscriptCard',
      'setTranscript',
      'setTranscriptSegments',
      'setTotalSectionList',
      'setIsTranscriptPlayOn',
      'setTimeStampSeekTime',
      'setIsRequestSetSeekTime',
      'setTranscriptInfo',
      'setTranscriptTimeout',
      'setIsTranscriptCardClicked',
      'setTranslateTranscript',
      'setCurrentClip',
      'setSubTitleData',
    ]),
    handleSegmentFound(tsSegment) {
      // console.log('Comment time hit the video time mark', tsSegment)
      this.setClickedTranscriptCard(tsSegment)
      this.isCardClicked = false // Reset the flag
      // this.scrollFocusedCard('transcriptCard', tsSegment.sgId, 'smooth')
    },
    findSegmentByIndex(filteredSegments, newTime) {
      const index = this.customBinarySearch(filteredSegments, newTime)
      return index !== -1 ? filteredSegments[index] : null
    },
    removeProcessedSegments(filteredSegments, newTime) {
      while (filteredSegments.length > 0 && filteredSegments[0].endTime < newTime) {
        filteredSegments.shift()
      }
    },
    customBinarySearch(array, target) {
      let left = 0
      let right = array.length - 1

      while (left <= right) {
        const middle = Math.floor((left + right) / 2)
        const segment = array[middle]

        if (target >= segment.startTime && target <= segment.endTime) {
          return middle
        } else if (target < segment.startTime) {
          right = middle - 1
        } else {
          left = middle + 1
        }
      }

      return -1
    },
    isTranscriptTimeWithinRange(tsTime, videoTime, threshold) {
      return Math.abs(tsTime - videoTime) <= threshold
    },
    hasTranscript() {
      if (this.currentClip?.transcriptInfo?.tsSegments) {
        this.storeTranscript()
      } else {
        this.resetTranscript()
      }
    },
    resetTranscript() {
      this.isEmptyTranscript = false
      this.isLoading = true
      this.transcriptArray = null
      this.transcriptSegments = null
      this.setTranscript(null)
      this.setTranscriptSegments(null)
      this.transcriptSegmentsIndex = 0
      this.filteredSegements = null
      this.searchItem = null

      this.setTranscriptInfo(null)

      // 기존에 걸려있던 5초 Timeout 해제
      if (this.transcriptTimeout) {
        clearTimeout(this.transcriptTimeout)
        this.setTranscriptTimeout(null)
      }
    },
    setFilteredSegments(segments) {
      this.filteredSegements = segments ? [...segments] : null
    },
    storeTranscript(transcript) {
      this.transcriptArray = transcript
      this.transcriptSegments = transcript.tsSegments
      this.setFilteredSegments(this.transcriptSegments)
      this.setTranscript(this.transcriptArray)
      this.setTranscriptSegments(this.transcriptSegments)
      this.searchItem = this.transcriptSegments
    },
    onClickTranscriptCard(card) {
      // console.log('onClickTranscriptCard', card)
      this.isCardClicked = true
      this.cardClickedId = card.sgId

      this.setClickedTranscriptCard(card)

      // this.setClickedTranscriptCard(card)
      if (!this.isEditing) {
        this.setSeekTime(card.startTime)
      }
      // this.setIsTranscriptCardClicked(true)
      // this.setIsTranscriptPlayOn(false)
    },
    setSeekTime(time) {
      if (time > 0) {
        let subtitleSyncTime = time + 0.0001
        this.setTimeStampSeekTime(subtitleSyncTime)
        this.setIsRequestSetSeekTime(true)
      } else {
        this.setTimeStampSeekTime(0.062 / 1000)
        this.setIsRequestSetSeekTime(true)
      }
    },
    //클릭 된 카드 스크롤 해주는 함수
    scrollFocusedCard(refName, id, behavior) {
      if (this.isMobile) return

      // Check if the given reference name exists
      const ref = this.$refs[`${refName}-${id}`]
      if (!ref) return

      // Get the first element matching the reference name
      const el = ref[0].$el

      if (el && el !== null && el !== undefined) {
        el.scrollIntoView({ behavior, block: 'center' })
      }
    },
    formatSeconds(seconds) {
      const date = new Date(seconds * 1000)
      const minutes = date.getUTCMinutes()
      const formattedSeconds = date.getUTCSeconds()

      return String(minutes).padStart(2, '0') + ':' + String(formattedSeconds).padStart(2, '0')
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 58) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    convertSecondsToTime(time) {
      // console.log('convertSecondsTo Time time', time)

      var hours = Math.floor(time / 3600)
      var minutes = Math.floor((time - hours * 3600) / 60)
      var seconds = Math.floor(time - hours * 3600 - minutes * 60)

      // 1시간 이상일 때
      if (hours > 0) {
        return (
          (hours < 10 ? '0' + hours : hours) +
          ':' +
          (minutes < 10 ? '0' + minutes : minutes) +
          ':' +
          (seconds < 10 ? '0' + seconds : seconds)
        )
      }
      // 1시간 미만일 때
      else {
        return (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      }
    },
    convertInputToTime(input) {
      let inputStr = input.replace(/:/g, '')

      if (inputStr.length > 6) {
        inputStr = inputStr.substring(inputStr.length - 6)
      }

      let time = inputStr.padStart(6, '0')
      time = time.replace(/(\d{2})(\d{2})(\d{2})/, '$1:$2:$3')

      const clipduration = Math.floor(this.currentClip.clipDuration)
      const durationInSeconds = Math.min(
        parseInt(time.slice(0, 2)) * 3600 + parseInt(time.slice(3, 5)) * 60 + parseInt(time.slice(6, 8)),
        clipduration
      )

      this.editedTimeStamp = String(durationInSeconds)

      // const durationFormatted =
      //   ('00' + Math.floor(durationInSeconds / 3600)).slice(-2) +
      //   ':' +
      //   ('00' + Math.floor((durationInSeconds % 3600) / 60)).slice(-2) +
      //   ':' +
      //   ('00' + (durationInSeconds % 60)).slice(-2)

      // return console.warn(durationFormatted)
    },
    editGoal(item, index) {
      this.isEditing = true
      this.oldValue = item.content
      // console.log(this.oldValue)
      this.editIndex = index
    },
    async submitEditGoal(index, isEdit) {
      // 수정일 경우
      this.isEditing = false
      if (isEdit) {
        try {
          this.isEditLoading = true

          if (this.editedTimeStamp !== '') {
            this.filteredItem[index]['startTime'] = this.editedTimeStamp
          }

          await updateTranscriptInfo(
            this,
            this.transcriptInfo['clipId'],
            this.transcriptInfo['tsId'],
            this.filteredItem[index]['sgId'],
            this.filteredItem[index]['content'],
            this.filteredItem[index]['startTime']
          )
        } catch (error) {
          console.log('update transcript error : ', error)
        } finally {
          this.isEditLoading = false
        }
      }
      this.editIndex = null
    },
    async deleteTranscript(item, index) {
      try {
        item.isDeleteLoading = true
        await updateTranscriptInfo(
          this,
          this.transcriptInfo['clipId'],
          this.transcriptInfo['tsId'],
          this.filteredItem[index]['sgId']
        )

        let tsIndex = this.transcriptInfo['tsSegments'].findIndex(
          (transcript) => transcript['sgId'] === this.filteredItem[index]['sgId']
        )
        if (tsIndex > -1) {
          if (this.transcriptInfo['tsSegments'].length > 1) this.transcriptInfo['tsSegments'].splice(tsIndex, 1)
          else this.transcriptInfo['tsSegments'] = null
        }
        this.storeTranscript(this.transcriptInfo)
      } catch (error) {
        console.log('delete transcript error : ', error)
      } finally {
        item.isDeleteLoading = false
      }
    },
    highlighted(txt) {
      if (this.search) {
        let search = this.search
        let regex = new RegExp(search, 'ig')
        let result = txt.replace(regex, '<b class="searched-text">$&</b>')
        return result
      } else {
        return txt
      }
    },
    allCopy() {
      const content = this.transcriptSegments
        .map((item) => `${this.convertSecondsToTime(item.startTime)}\n${item.content}`)
        .join('\n\n')
      navigator.clipboard.writeText(content).then(() => {
        // notify(this, 'Success', this.$t('copiedClipboardText'), 'success')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('copiedClipboardText'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      })
    },
    copy(item) {
      const content = `${this.convertSecondsToTime(item.startTime)}\n${item.content}`
      navigator.clipboard.writeText(content).then(() => {
        // notify(this, 'Success', this.$t('copiedClipboardText'), 'success')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('copiedClipboardText'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      })
    },
  },
  computed: {
    ...mapGetters([
      'isMtOrganizer',
      'isWsOwner',
      'isWsManager',
      'commentList',
      'sectionIndex',
      'seekTimeDecimal',
      'clipIndex',
      'clipList',
      'chkMtPublic',
      'totalSectionList',
      'controlbarIconList',
      'currentClip',
      'currentMt',
      'selectedCh',
      'clickedTranscriptCard',
      'currentClip',
      'isPauseIcon',
      'isTranscriptPlayOn',
      'transcriptInfo',
      'transcriptTimeout',
      'wsClipCnt',
    ]),

    ...mapState({
      userInfo: (state) => {
        return state.auth.userInfo
      },
      isPlayerPause: (state) => {
        return state.clip.isPlayerPause
      },
    }),

    editTimeStamp() {
      return (item) => {
        if (item && item.startTime) {
          return this.convertSecondsToTime(item.startTime)
        }
      }
    },
    transcriptStatus() {
      return this.currentClip['transcriptStatus']
    },
    // 변환 중, 변환 성공 시에는 Loading 을 보여줄지 체크
    isShowLoading() {
      return this.transcriptStatus !== undefined && this.transcriptStatus !== null && this.transcriptStatus === 0
    },
    // 변환 성공
    isShowSuccess() {
      return this.transcriptStatus !== undefined && this.transcriptStatus !== null && this.transcriptStatus === 1
    },

    // 변환 실패
    isShowFail() {
      return this.transcriptStatus !== undefined && this.transcriptStatus !== null && this.transcriptStatus === 2
    },

    // 사용자가 체크를 통해 선택하지 않거나 영상이 짧아서 표시 되지 않는 경우
    isUncheckedOrTooShort() {
      return this.transcriptStatus !== undefined && this.transcriptStatus !== null && this.transcriptStatus === 3
    },

    computedWsClipCnt() {
      return this.wsClipCnt ?? {}
    },

    clickedTranscriptCardComparison() {
      return (item) => {
        if (this.clickedTranscriptCard) {
          return item.sgId === this.clickedTranscriptCard.sgId
        }
        return false
      }
    },

    filteredItem() {
      if (this.search) {
        return this.searchItem.filter((item) => {
          return item.content.toLowerCase().match(this.search.toLowerCase())
        })
      } else {
        return this.searchItem
      }
    },

    detailCommentInputComponent() {
      return this.$root.$refs[`DetailCommentInput-${this.sectionIndex}`]
    },
    boxCommentComponent() {
      return this.$root.$refs[`BoxComment-${this.sectionIndex}`]
    },
    commentPlayComponent() {
      return this.$root.$refs[`CommentPlay-${this.sectionIndex}`]
    },
    currentUser() {
      let user = this.$store.getters.userInfo
      return user && user !== null ? user : {}
    },
    isSectionMt() {
      return this.currentMt.sectionInfo && this.currentMt.sectionInfo !== null && this.currentMt.sectionInfo.length > 0
    },
    isMobile() {
      return isMobile()
    },
    isLastClip() {
      return (
        this.clipList &&
        this.clipList !== null &&
        this.clipList.length > 0 &&
        this.$store.getters.isLastClip &&
        this.$store.getters.isLastClip !== null
      )
    },
    isFeedback: (state) => {
      return state.clip.isFeedback
    },
    isInIframe() {
      return window.location != window.parent.location
    },
    isClOrganizer() {
      let clipUploader = this.currentClip.clipUploader
      if (clipUploader && this.userInfo) {
        return clipUploader.userId === this.userInfo.userId
      }
      return false
    },
  },
  watch: {
    // websocket 에서 들어오는 data 감지
    transcriptInfo(transcript) {
      if (transcript) {
        if (transcript && transcript['tsSegments'] && transcript['tsSegments'].length > 0) {
          this.storeTranscript(transcript)
          // 자막 정보가 있다면 넣어준다.
          if (transcript['subTitleData']) {
            this.totalSectionList[this.sectionIndex].clipList[this.clipIndex]['subTitleData'] =
              transcript['subTitleData']
            this.currentClip['subTitleData'] = transcript['subTitleData']
            this.setSubTitleData(transcript['subTitleData'])
            this.setTotalSectionList(this.totalSectionList)
            this.setCurrentClip(this.currentClip)
          }
        } else if (transcript && transcript['tsSegments'] && transcript['tsSegments'].length === 0) {
          // 로딩이 다 끝났지만 데이터가 비어있는 경우 체크
          this.isEmptyTranscript = true
        }
        this.isLoading = false
      }
    },
    isPauseIcon(bool) {
      this.setIsTranscriptPlayOn(bool)
    },

    seekTimeDecimal(newTime) {
      if (!this.transcriptArray || !this.transcriptSegments) {
        return
      }
      // this.setFilteredSegments(this.transcriptSegments)
      // this.removeProcessedSegments(this.filteredSegements, newTime)

      const tsSegment = this.findSegmentByIndex(this.filteredSegements, newTime)

      if (tsSegment && this.isTranscriptPlayOn && (this.isCardClicked ? tsSegment.sgId === this.cardClickedId : true)) {
        // console.log('tsSegment', tsSegment)
        this.handleSegmentFound(tsSegment)
      }

      // if (tsSegment && this.isTranscriptPlayOn) {
      //   console.log('tsSegment', tsSegment)
      //   this.handleSegmentFound(tsSegment)
      // }
    },

    currentClip() {
      // Transcript 정보는 초기화
      this.resetTranscript()
      this.editIndex = null
      this.isEditing = false

      // Transcript 정보 호출
      this.getTranscriptInfo()
    },

    search(val) {
      if (!val) {
        // this.searchItem = this.dummyData
        this.searchItem = this.transcriptSegments
      }
    },
    searchOn(val) {
      if (!val) {
        this.search = ''
        // this.searchItem = this.dummyData
        this.searchItem = this.transcriptSegments
      } else {
        setTimeout(() => document.querySelector('#transcriptSearchField').focus())
      }
    },
  },
}
</script>

<style scoped>
.transcriptCardClicked,
.transcriptCardClicked:focus-within {
  box-shadow: 0px 0px 0px 1px #ff575f !important;
}

.wrap-transcript-card {
  background-color: rgb(49, 67, 79);
  width: calc(100% - 2px);
  margin-left: 1px;
}
.transcript-col {
  align-self: stretch;
  flex-direction: column;
  align-items: end;
  width: 50px;
}
.transcript-col-btn {
  position: absolute;
  top: 8px;
  right: 15px;
  width: 36px;
  border-radius: 5px;
}
.transcript-content {
  font-size: 13px;
  display: flex;
  align-self: flex-start;
  color: #96a7af;
}
.transcript-timestamp {
  font-size: 14px;
  font-weight: 500;
}
.container-menu-transcript {
  width: 128px;
  padding: 4px;
  border-radius: 5px;
  border: 1px solid #475e69;
  background-color: #1d292f;
  overflow: hidden;
}
.top-menu-transcript >>> .row--dense > .col {
  padding: 4px 0px 4px 4px !important;
}
.container-menu-transcript >>> .row--dense > .col {
  padding: 4px !important;
}
.container-menu-transcript >>> button span {
  font-size: 13px;
  font-weight: 400;
}

.container-menu-transcript >>> button {
  width: 120px;
  justify-content: start;
}
.container-menu-transcript >>> button:hover {
  background-color: #161d21;
}
.container-btn-edit >>> button span,
.container-btn-reply >>> button span {
  font-size: 12px;
  font-weight: 400;
}
.wrap-edit-menu >>> button {
  height: 30px !important;
  padding: 0 12px !important;
}
.wrap-edit-menu >>> button span {
  font-size: 13px;
  font-weight: 400;
}
.btn-save {
  border: 1px solid #475e69;
}
.wrap-transcript-card:hover .dot-comment {
  display: inline-flex !important;
}
.dot-comment >>> button.dot-menu {
  padding: 0;
  height: 36px !important;
  min-width: 36px;
}
.top-menu-transcript >>> button span {
  font-weight: 400;
}
.top-menu-transcript >>> button {
  width: 120px;
  height: 30px !important;
  background-color: #21343b;
  font-size: 13px;
  border-radius: 3px;
}
.top-menu-transcript >>> button.close {
  width: 30px;
  height: 30px !important;
  background-color: transparent;
  border-radius: 3px;
}
.top-menu-transcript >>> button.close span {
  font-size: 20px;
  font-weight: 400;
}
.top-menu-transcript >>> .v-text-field {
  padding: 0;
}
.top-menu-transcript >>> .v-text-field.v-text-field--solo .v-input__control {
  min-height: 32px;
}
.top-menu-transcript >>> .v-text-field .v-label {
  top: 2px;
  font-size: 14px;
}
.top-menu-transcript >>> .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background-color: #21343b;
  box-shadow: none;
}
.top-menu-transcript >>> .v-text-field .v-input__prepend-inner {
  margin: 2px 0 0 0;
}
.top-menu-transcript >>> .v-input__icon i {
  font-size: 20px;
}
.top-menu-transcript >>> .v-input input {
  max-height: unset !important;
  padding: 0;
  font-size: 14px;
}
.btn-span {
  color: #ddd;
  font-size: 18px;
  font-weight: 400;
}
.transcript-content >>> .searched-text {
  color: #ffc542 !important;
}
.edit-timestamp {
  font-size: 14px;
  font-weight: 500;
}
.edit-content {
  font-size: 13px;
}
.edit-timestamp >>> textarea,
.edit-content >>> textarea {
  line-height: unset !important;
  padding: 0 !important;
  margin: 0 !important;
  height: auto !important;
}
.edit-timestamp >>> textarea {
  text-align: right;
}
.edit-content >>> textarea {
  overflow: auto !important;
}
.edit-timestamp >>> .v-input__slot,
.edit-content >>> .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}
.loading-text-big {
  font-size: 18px;
  font-weight: 600;
  color: #96a7af;
}
.loading-text-small {
  font-size: 13px;
  color: #717e85;
}
.v-btn.v-btn--disabled:disabled {
  background-color: rgba(22, 29, 33, 0.4) !important;
}
</style>
